exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-08426de7].mce-last{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}[data-v-08426de7] .mce-toolbar{width:500px;overflow-x:auto}[data-v-08426de7] ::-webkit-scrollbar{height:8px}", ""]);

// exports
